import React, { useMemo } from "react";
import { Box, Typography } from "@material-ui/core";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import MessageTable, { countColumns } from "./MessageTable";
import { useStyles } from './MessagesTimelineTableStyles';

const MessagesTimelineTable = ({ batches }) => {
  const classes = useStyles();

  // Flatten messages from all batches (all messages are from same batch)
  const allMessages = batches ? batches.flatMap(batch => 
    batch.messages.map(msg => ({ ...msg, batchNumber: batch.batchNumber }))
  ) : [];

  // Calculate the maximum number of columns across all messages
  // This ensures all tables use the same column width for perfect vertical alignment
  const maxColumns = useMemo(() => {
    if (!allMessages || allMessages.length === 0) return 13; // Default fallback
    return Math.max(...allMessages.map(message => countColumns(message)));
  }, [allMessages]);

  return (
    <Timeline className={classes.timeline} align="left">
      {allMessages.map((message, msgIdx) => {
        const isFirst = msgIdx === 0;
        const isLast = msgIdx === allMessages.length - 1;
        return (
          <TimelineItem key={message.id || msgIdx}>
            <TimelineSeparator>
              {isFirst ? (
                <Box className={classes.dashedLine} />
              ) : (
                <TimelineConnector />
              )}
              {/* Dot wrapper - stretches to full height and centers dot */}
              <Box 
                style={{
                  position: "relative",
                  width: "2px",
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  minHeight: "40px",
                }}
              >
                {/* Connector line behind the dot - spans full height */}
                <Box
                  style={{
                    position: "absolute",
                    width: "2px",
                    height: "100%",
                    backgroundColor: "#ec6535",
                    top: 0,
                    left: 0,
                    zIndex: 0,
                  }}
                />
                {/* Dot centered on the line */}
                <TimelineDot 
                  className={isFirst ? classes.firstDot : ""}
                  style={{
                    ...(isFirst ? { backgroundColor: "#fff", border: "2px solid #ec6535" } : {}),
                    width: "16px",
                    height: "16px",
                    position: "relative",
                    zIndex: 2,
                    flexShrink: 0,
                  }}
                />
              </Box>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent 
              className={`${classes.timelineContent} ${isFirst ? classes.firstTimelineContent : ''} ${isLast ? classes.lastTimelineContent : ''}`}
            >
              <MessageTable message={message} maxColumns={maxColumns} />
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

export default MessagesTimelineTable;

